import { render } from "./File.vue?vue&type=template&id=01ccaa5a"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import "./File.vue?vue&type=style&index=0&id=01ccaa5a&lang=css"

import exportComponent from "/Users/lucas/Documents/repo/tiototo-users-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__